import { ResourceService } from "./resource.service";
import { Injectable } from "@angular/core";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class NavigationService extends ResourceService<any> {

    constructor(
        http: HttpClient, 
        settings: GlobalSettings, 
        authService: AuthenticationService) {
            super(http, "gateway/Navigations", settings.processosUrl, authService)
    }
}